import InputField from 'components/fields/InputField';
import { useEffect, useState } from 'react';

const AddQuestion = ({ setQuestion, question, setDisable }) => {
  const [errors, setErrors] = useState([]);
  const [pdfName, setPdfName] = useState('');
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setQuestion((prev) => ({ ...prev, [id]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === 'application/pdf') {
        setPdfName(file.name);
        setQuestion((prev) => ({ ...prev, pdfFile: file }));

        const fileUrl = URL.createObjectURL(file);
        setPdfPreviewUrl(fileUrl);
      } else {
        setErrors([...errors, 'Only PDF files are allowed.']);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (pdfPreviewUrl) {
        URL.revokeObjectURL(pdfPreviewUrl);
      }
    };
  }, [pdfPreviewUrl]);

  const validateInputs = () => {
    const newErrors = [];
    if (!question.title) newErrors.push('Assignment Title is required.');
    if (!question.dueDate) newErrors.push('Question Due Date is required.');

    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  };

  useEffect(() => {
    validateInputs();
  }, [question]);

  const openPdfInNewTab = () => {
    if (pdfPreviewUrl) {
      window.open(pdfPreviewUrl, '_blank');
    }
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="pb-[5px] pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Practical Assignment Details :
      </h4>

      <InputField
        extra="mb-3"
        label="Practical Assignment Title"
        placeholder="Enter Assignment Title"
        id="title"
        type="text"
        value={question?.title}
        onChange={handleInputChange}
      />

      <InputField
        extra="mb-3"
        label="Due Date"
        placeholder="Enter Assignment Title"
        id="dueDate"
        type="date"
        value={question?.dueDate}
        onChange={handleInputChange}
      />

      {/* PDF Upload Section */}
      <div className="mt-5">
        <label className="text-sm text-navy-700 dark:text-white">
          Upload PDF Document
        </label>
        <div className="mt-2 flex items-center">
          <label className="flex h-12 w-full cursor-pointer items-center justify-center rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-600 transition-all hover:bg-gray-100 dark:border-white/10 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-800">
            <input
              type="file"
              id="pdfFile"
              accept="application/pdf"
              className="hidden"
              onChange={handleFileChange}
            />
            {pdfName ? pdfName : 'Choose PDF file'}
          </label>
        </div>

        {/* PDF Preview Button */}
        {pdfPreviewUrl && (
          <div className="mt-3">
            <button
              onClick={openPdfInNewTab}
              className="flex items-center rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none"
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mr-2 h-4 w-4"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
              </svg>
              View PDF
            </button>
          </div>
        )}
      </div>

      {/* Error Messages */}
      {errors.length > 0 && (
        <div className="mt-4 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddQuestion;
